import { InsuranceHero } from "../shared/InsuranceHero";

export const HomeHero = () => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Home Insurance",
    "serviceType": "Insurance",
    "category": "Home Insurance",
    "provider": {
      "@type": "InsuranceAgency",
      "name": "Allen Insurance Agency",
      "areaServed": "Illinois"
    },
    "description": "Comprehensive home insurance coverage protecting your property and belongings.",
    "offers": {
      "@type": "Offer",
      "availability": "https://schema.org/InStock"
    }
  };

  return (
    <InsuranceHero
      title="Protect Your Home"
      description="Secure your home and belongings with our comprehensive coverage options. Get peace of mind knowing your biggest investment is protected."
      jsonLd={jsonLd}
    />
  );
};